import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
      Dialog,
      DialogContent,
      DialogDescription,
      DialogFooter,
      DialogHeader,
      DialogTitle,
} from "@/components/ui/dialog";

interface ConfirmationDialogProps {
      open: boolean;
      onOpenChange: (open: boolean) => void;
      title: string;
      description: string;
      confirmText?: string;
      cancelText?: string;
      onConfirm: () => void;
      isPending?: boolean;
      variant?: "destructive" | "default";
}

export function ConfirmationDialog({
      open,
      onOpenChange,
      title,
      description,
      confirmText = "Confirm",
      cancelText = "Cancel",
      onConfirm,
      isPending = false,
      variant = "destructive",
}: ConfirmationDialogProps) {
      const handleConfirm = () => {
            onConfirm();
      };

      return (
            <Dialog open={open} onOpenChange={onOpenChange}>
                  <DialogContent className="sm:max-w-md">
                        <DialogHeader>
                              <div className="flex items-center gap-3">
                                    {variant === "destructive" && (
                                          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-destructive/10">
                                                <AlertTriangle className="h-5 w-5 text-destructive" />
                                          </div>
                                    )}
                                    <div className="flex flex-col gap-1">
                                          <DialogTitle>{title}</DialogTitle>
                                          <DialogDescription>{description}</DialogDescription>
                                    </div>
                              </div>
                        </DialogHeader>
                        <DialogFooter className="mt-4">
                              <Button
                                    type="button"
                                    variant="outline"
                                    className="bg-card"
                                    onClick={() => onOpenChange(false)}
                                    disabled={isPending}
                              >
                                    {cancelText}
                              </Button>
                              <Button type="button" variant={variant} onClick={handleConfirm} disabled={isPending}>
                                    {isPending ? "Processing..." : confirmText}
                              </Button>
                        </DialogFooter>
                  </DialogContent>
            </Dialog>
      );
}
